export enum DocumentRejectionReasonEnum {
  BLURRY = 'BLURRY',
  INCORRECT_DOCUMENT = 'INCORRECT_DOCUMENT',
  EXPIRED = 'EXPIRED',
  OTHER = 'OTHER',
}
